const translations = {
  title: 'Historial de activadores disparados',
  name: 'Nombre',
  status: 'Estado',
  originEntity: 'Entidad de origen',
  destinationEntity: 'Entidad destino',
  date: 'Fecha',
  idLabel: 'ID: {{id}}',
  triggerFired: 'Activador disparado',
  cardsViewComingSoon: 'Vista de tarjetas (próximamente)',
  seeDetails: 'Ver detalles',
  runManually: 'Ejecutar manualmente',
  confirmRetry: '¿Está seguro de que desea ejecutar nuevamente?',
  'tabs.result': 'Resultado',
  'tabs.payload': 'Payload',
  'tabs.entity': 'Entidad',
  'tabs.trigger': 'Activador',
  'tabs.rest': 'Resto'
}

export default translations
